import { render, staticRenderFns } from "./project-management-archive.html?vue&type=template&id=78a6c754&"
import script from "./ProjectManagementArchive.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports